<div class="layout-wrapper" [ngClass]="containerClass()">
  <d2d-impersonation-banner />
  <div app-sidebar></div>
  <div class="layout-content-wrapper">
    <div class="layout-content-wrapper-inside">
      <div app-topbar></div>
      <d2d-status-banner-strip />
      <div class="layout-content">
        <div app-breadcrumb></div>
        <router-outlet></router-outlet>
        <d2d-notification-template />
      </div>

      @if (showDock()) {
        <p-dock #dockEl [model]="items()" position="bottom">
          <ng-template #item let-item>
            <a [href]="item._appUrl" target="_blank" rel="noopener noreferrer">
              @if (item.icon) {
                <img
                  [alt]="item.label"
                  [src]="item.icon"
                  class="w-7 h-7 object-contain"
                  referrerpolicy="no-referrer"
                />
              } @else {
                <div
                  class="text-gray-400 dark:text-gray-500 font-bold text-2xl leading-none select-none grid place-items-center w-7 h-7"
                >
                  {{ (item.label || 'A')[0] | uppercase }}
                </div>
              }
            </a>
          </ng-template>
        </p-dock>
      }
      <div app-footer></div>
    </div>
  </div>
  <app-configurator />
  <div app-search></div>
  <!-- Speed dial for assigned commercial / supervisor contact -->
  @if (assignedCommercial() || mySupervisor()) {
    <p-speeddial
      [model]="speedDialItems"
      direction="up"
      mask
      [style]="{
        position: 'fixed',
        right: '1rem',
        bottom: '1rem',
        zIndex: '1000',
        alignItems: 'end',
      }"
      maskClassName="z-[999] bg-black/50 backdrop-blur-sm w-full h-full fixed top-0"
      buttonClassName="shadow-md"
    >
      <ng-template #item let-item>
        <div
          class="flex items-center gap-2 group cursor-pointer"
          tabindex="0"
          role="button"
          (click)="item.command?.($event)"
          (keydown.enter)="item.command?.($event)"
          (keydown.space)="item.command?.($event)"
        >
          <!-- Texto que aparece al pasar el mouse -->
          <span
            class="text-white text-sm w-0 opacity-0 group-hover:w-auto group-hover:opacity-100 transition-all duration-300 overflow-hidden max-h-7"
          >
            {{ item.label }}
          </span>
          <!-- Botón con ícono -->
          <p-button [icon]="item.icon" severity="secondary" rounded size="large" />
        </div>
      </ng-template>
    </p-speeddial>
  }

  <!-- Commercial drawer -->
  <app-commercial-drawer [(visible)]="showCommercialDrawer" [commercial]="assignedCommercial()" />

  <!-- Supervisor drawer (e.g. a Comercial's Jefe de Equipo) -->
  <app-commercial-drawer
    [(visible)]="showSupervisorDrawer"
    [commercial]="mySupervisor()"
    [header]="supervisorDrawerHeader()"
  />

  <!-- Tools FAB: mobile only when >4 items -->
  @if (showToolsFab()) {
    <div
      class="fixed z-[1000] right-4 transition-all duration-200"
      [class.bottom-4]="!assignedCommercial() && !mySupervisor()"
      [class.bottom-20]="!!assignedCommercial() || !!mySupervisor()"
    >
      <p-button
        icon="pi pi-th-large"
        rounded
        size="large"
        severity="secondary"
        styleClass="shadow-md"
        pTooltip="Herramientas"
        tooltipPosition="left"
        (click)="toggleToolsDrawer()"
      />
    </div>
  }

  <!-- Tools drawer overlay + panel -->
  @if (showToolsDrawer()) {
    <div
      class="fixed inset-0 z-[1099]"
      (click)="closeToolsDrawer()"
      tabindex="0"
      role="button"
      (keydown.enter)="closeToolsDrawer()"
    ></div>
    <nav
      class="tools-drawer-panel"
      [ngStyle]="{ bottom: assignedCommercial() || mySupervisor() ? '9rem' : '5rem' }"
    >
      @for (item of items(); track item.label) {
        <a
          [href]="item['_appUrl']"
          target="_blank"
          rel="noopener noreferrer"
          class="tools-drawer-item"
          [title]="item.label || ''"
          (click)="closeToolsDrawer()"
        >
          @if (item.icon) {
            <img
              [src]="item.icon"
              [alt]="item.label"
              class="w-9 h-9 object-contain"
              referrerpolicy="no-referrer"
            />
          } @else {
            <div
              class="text-gray-400 dark:text-gray-500 font-bold text-2xl leading-none select-none grid place-items-center w-9 h-9"
            >
              {{ (item.label || 'A')[0] | uppercase }}
            </div>
          }
        </a>
      }
    </nav>
  }

  <div app-rightmenu></div>
  <div class="layout-mask animate-fadein"></div>
</div>
